class AddSessionsToPackageReq {
    constructor() {
        this.quantity = null;
        this.packageId = null;
        this.sessionId = null;
        this.finalPrice = null;
    }
}
export default AddSessionsToPackageReq;